import { __assign, __awaiter, __generator } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack, Typography } from "@mui/material";
import { useMemo, useRef, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useStoreFileViewerContext } from "../../hooks/context";
import { uploadFiles } from "../UploadPopover/hooks";
import { FieldsForm, PangeaModal } from "@pangeacyber/react-mui-shared";
import { getCreateProtectedFileFields } from "./fields";
var CreateNewProtectedFileButton = function (_a) {
    var ButtonProps = _a.ButtonProps, onClose = _a.onClose;
    var _b = useStoreFileViewerContext(), apiRef = _b.apiRef, reload = _b.reload, parent = _b.parent, configurations = _b.configurations;
    var inputRef = useRef();
    var _c = useState(), files = _c[0], setFiles = _c[1];
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var handleClose = function () {
        setFiles(undefined);
        setOpen(false);
        onClose();
    };
    var handleUpload = function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!files)
                return [2 /*return*/];
            uploadFiles(files, undefined, body);
            handleClose();
            return [2 /*return*/];
        });
    }); };
    var obj = useMemo(function () {
        return {};
    }, []);
    var fields = useMemo(function () {
        var _a;
        return getCreateProtectedFileFields({
            policy: (_a = configurations === null || configurations === void 0 ? void 0 : configurations.passwordPolicy) !== null && _a !== void 0 ? _a : {
                chars_min: 8,
            },
        });
    }, [configurations]);
    return (_jsxs(_Fragment, { children: [_jsx("input", { 
                // @ts-ignore
                ref: inputRef, style: { display: "none" }, type: "file", onChange: function (e) {
                    if (e.target.files) {
                        setFiles(e.target.files);
                        setOpen(true);
                    }
                } }), _jsx(Button, __assign({ variant: "text", disabled: loading }, ButtonProps, { startIcon: _jsx(LockOutlinedIcon, { fontSize: "small" }), onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: "Password protected file" })), _jsx(PangeaModal, { open: open, onClose: handleClose, displayCloseIcon: true, title: "", header: _jsxs(Stack, { children: [_jsx(Stack, { direction: "row", width: "100%", alignItems: "center", justifyContent: "space-between", children: _jsx(Typography, { variant: "h5", sx: { overflow: "hidden", wordBreak: "break-all" }, children: "Protect using password" }) }), _jsx(Typography, { variant: "body2", color: "textSecondary", children: "Requires a password to decrypt before downloading." })] }), size: "medium", children: _jsx(_Fragment, { children: _jsx(FieldsForm, { object: obj, fields: fields, clearable: true, onCancel: handleClose, onSubmit: function (values) {
                            var _a;
                            return handleUpload({
                                password: (_a = values.password) !== null && _a !== void 0 ? _a : "",
                                password_algorithm: "AES-CFB-256",
                            }).finally(handleClose);
                        }, disabled: loading, StackSx: {
                            ".MuiFormControl-root": {
                                margin: 0,
                            },
                        } }) }) })] }));
};
export default CreateNewProtectedFileButton;
